import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import {
  HelpCircle as HelpCircleIcon,
  PlusCircle as PlusCircleIcon,
  File as FileIcon,
} from 'react-feather'
import { reverse } from 'named-urls'
import {
  Box,
  Button,
  Card,
  Hidden,
  Tab,
  TablePagination,
  Tabs,
  Tooltip,
} from '@material-ui/core'

import {
  ButtonAction,
  Container,
  ContentHeader,
  DriveTour,
  FilterButton,
  Filters,
  MenuButton,
  Page,
} from 'components'
import { DeleteReceiptModal, ReceiptTable } from './components'

import helpers from 'helpers'

import useFetch from 'hooks/useFetch'
import useFilter from 'hooks/useFilter'
import usePagination from 'hooks/usePagination'

import { routes } from 'Routes'
import useStyles from './styles'
import * as service from 'service'
import constants from 'constants/index'

const ConsentMain = () => {
  const classes = useStyles()
  const filter = useFilter()
  const history = useHistory()

  const {
    CONSENT_RECEIPTS_TABS,
    ALL_STATUSES_CONSENT_RECEIPT,
    AUTHORIZED_CONSENT,
    REVOKED_CONSENT,
    PLATFORM_FILTER,
    PENDENT_CONSENT,
  } = constants.consent

  const [tab, setTab] = useState(CONSENT_RECEIPTS_TABS[0].value)
  const [statuses, setStatuses] = useState(ALL_STATUSES_CONSENT_RECEIPT)
  const [openDeleteReceiptModal, setOpenDeleteReceiptModal] = useState(false)
  const [receiptData, setReceiptData] = useState({})
  const [openTour, setOpenTour] = useState(false)

  const { perPage, page, handleChangePage, handleChangeRowsPerPage } =
    usePagination(10)

  const handleChangeTab = (_, value) => {
    setTab(value)
    if (value === CONSENT_RECEIPTS_TABS[0].value) {
      return setStatuses(ALL_STATUSES_CONSENT_RECEIPT)
    }
    if (value === CONSENT_RECEIPTS_TABS[1].value) {
      return setStatuses(AUTHORIZED_CONSENT)
    }
    if (value === CONSENT_RECEIPTS_TABS[2].value) {
      return setStatuses(REVOKED_CONSENT)
    }
    if (value === CONSENT_RECEIPTS_TABS[3].value) {
      return setStatuses(PENDENT_CONSENT)
    }
  }

  const { response, isLoading, refresh } = useFetch(
    service.dponet.consent.listReceipts,
    {
      perPage,
      page,
      statuses: statuses,
      ...filter.filters,
    },
    [perPage, page, statuses, filter.filters],
  )

  const receipts = response?.data?.consentFormAnswers

  const handleNew = () => history.push(routes.consent.consentReceiptNew)
  const handleOpenDeleteReceiptModal = (currentReceipt) => {
    setReceiptData(currentReceipt)
    setOpenDeleteReceiptModal(true)
  }

  const handleRedirectToDetails = ({ consentReceiptId, consentFormId }) =>
    history.push(
      reverse(routes.consent.consentReceiptDetails, {
        consentFormId,
        consentReceiptId,
      }),
    )

  const handleOpenTour = () => {
    const where = 'Recibo de consentimento'
    const title = 'Tour'

    const params = {
      action: 'tour-recibos-consentimento',
    }

    helpers.mixpanel.track(where, title, params)
    setOpenTour(true)
  }

  const handleRedirectToConsentReport = () => {
    history.push(routes.reports.consent)
  }

  return (
    <Page title="Recibo de Consentimento">
      <Container maxWidth={false}>
        <ContentHeader title="Recibo de Consentimento">
          <Tooltip title="Iniciar o tour guiado">
            <Button
              id={constants.consent.RECEIPT_MAIN_DRIVER_STEP_0}
              variant="contained"
              color="primary"
              startIcon={<HelpCircleIcon size={20} />}
              onClick={handleOpenTour}
              fullWidth
            >
              Tutorial
            </Button>
          </Tooltip>
          <Hidden mdDown>
            <ButtonAction
              variant="contained"
              color="primary"
              action={handleNew}
              startIcon={<PlusCircleIcon width="18" />}
              name="Registrar Consentimento"
              fullWidth
            />

            <ButtonAction
              variant="outlined"
              color="primary"
              action={handleRedirectToConsentReport}
              startIcon={<FileIcon width="18" />}
              name="Gerar Relatório"
              fullWidth
            />
          </Hidden>
          <Hidden lgUp>
            <MenuButton
              anchorElement={Button}
              anchorOptions={{
                className: classes.optionsButton,
                variant: 'contained',
              }}
              anchorChildren="Opções"
            >
              <ButtonAction
                color="secondary"
                action={handleNew}
                fullWidth
                name="Registrar Consentimento"
              />
              <ButtonAction
                color="secondary"
                action={handleRedirectToConsentReport}
                fullWidth
                name="Gerar Relatório"
              />
            </MenuButton>
          </Hidden>
          <FilterButton setDrawerOpen={filter.setDrawerOpen} fullWidth />
        </ContentHeader>
        <Box>
          <Tabs
            value={tab}
            indicatorColor="primary"
            textColor="primary"
            onChange={handleChangeTab}
          >
            {CONSENT_RECEIPTS_TABS.map((tab) => (
              <Tab
                key={tab.value}
                label={tab.label}
                value={tab.value}
                onClick={(event) => handleChangeTab(event, tab.value)}
              />
            ))}
          </Tabs>
        </Box>
        {!isLoading && (
          <Card>
            <ReceiptTable
              receipts={receipts}
              refresh={refresh}
              handleOpen={handleOpenDeleteReceiptModal}
              navigateAction={handleRedirectToDetails}
            />
            <TablePagination
              component="div"
              count={response?.data?.meta?.totalCount || 0}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              page={page - 1}
              rowsPerPage={perPage}
              labelRowsPerPage={<Hidden smDown>Por página</Hidden>}
              rowsPerPageOptions={[5, 10, 25, 100]}
              nextIconButtonProps={{ size: 'small' }}
              backIconButtonProps={{ size: 'small' }}
            />
          </Card>
        )}
        <Filters filter={filter}>
          <input textfieldinput="true" label="Identificador" name="id" />
          <input
            textfieldinput="true"
            label="Identificador do formulário"
            name="consentFormId"
          />
          <input
            textfieldinput="true"
            label="Título do formulário"
            name="title"
          />
          <select textfieldinput="true" label="Plataforma" name="platform">
            <option value=""></option>
            {PLATFORM_FILTER.map((status) => (
              <option key={status.id} value={status.id}>
                {status.name}
              </option>
            ))}
          </select>

          <input textfieldinput="true" label="E-mail" name="userEmail" />
          <input
            textfieldinput="true"
            label="Nome completo"
            name="userFullname"
          />
        </Filters>
      </Container>
      <DeleteReceiptModal
        receipt={receiptData}
        open={openDeleteReceiptModal}
        setOpen={setOpenDeleteReceiptModal}
        refresh={refresh}
      />
      <DriveTour
        stepsMatrix={constants.consent.RECEIPT_MAIN_DRIVER_STEPS_OBJECT}
        open={openTour}
        setOpen={setOpenTour}
      />
    </Page>
  )
}

export default ConsentMain
